import { useCallback } from "react";

import { AuthWrapper } from "@/lib/aws-amplify";

import { DevelopmentTools } from "@/hooks/use-development-tools";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

import { useAuth } from "@/providers";

export const useSignOut = () => {
	const { signOutCallback } = useAuth();
	const { consoleErrorOnlyDevMode } = DevelopmentTools();

	const signOut = useCallback(
		() =>
			AuthWrapper.authSignOut()
				.then(() => {
					notifyUserEventInfo({
						variant: "default",
						title: "サインアウトしました",
						description: "またのご利用をお待ちしております。",
					});
					signOutCallback();
				})
				.catch((err) => {
					consoleErrorOnlyDevMode(err);
					notifyUserEventInfo({
						variant: "error",
						title: "サインアウトに失敗しました",
						description: "もう一度お試しください。",
					});
				}),
		[consoleErrorOnlyDevMode, signOutCallback],
	);

	return {
		signOut,
	};
};
